import React, { useState } from "react";

const Prazo = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <div className="w-full my-8 md:my-12">
        <div
          className="relative group w-full h-64 sm:h-80 cursor-pointer overflow-hidden"
          onClick={() => setShowModal(true)}
        >
          <img
            src="https://flitzstorebrapi.duckdns.org/uploads/customize/file_000000004ce461f7982168cf0f17327b.png"
            alt="FlitzStoreBR Banner"
            className="w-full h-full object-cover transition-transform duration-500 transform group-hover:scale-105"
          />
          <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-40 text-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
            <h2 className="text-white font-extrabold text-2xl sm:text-4xl drop-shadow-md">
              FRETE RÁPIDO VIA CORREIOS
            </h2>
            <p className="text-white text-sm sm:text-lg mt-2 px-4">
              Entregamos em todo o Brasil com agilidade e segurança.
            </p>
          </div>
          <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black via-transparent to-transparent">
            <p className="text-white text-xs sm:text-sm opacity-80 text-center">
              Acompanhe seu pedido do envio à entrega direto no seu WhatsApp.
            </p>
          </div>
        </div>
      </div>

      {/* Modal fullscreen estilo Story */}
      {showModal && (
        <div
          className="fixed inset-0 z-50 bg-black bg-opacity-90 flex items-center justify-center"
          onClick={() => setShowModal(false)}
        >
          <img
            src="https://flitzstorebrapi.duckdns.org/uploads/customize/file_000000004ce461f7982168cf0f17327b.png"
            alt="FlitzStoreBR Modal"
            className="max-h-screen max-w-screen"
          />
        </div>
      )}
    </>
  );
};

export default Prazo;